export default "__VITE_ASSET__CjIiDmYT__"